export const fetchCommentsClientTranslations = async (httpClient, language, errorHandler) => {
    const { withErrorHandler, getResolvedError } = errorHandler;
    try {
        const response = await withErrorHandler(() => httpClient.get(`/_serverless/comments-web-translations-proxy/comments-ooi/${language}`), { errorCodesMap: {} });
        return response;
    }
    catch (error) {
        getResolvedError(error);
        throw error;
    }
};
//# sourceMappingURL=index.js.map